import { createStyles } from '@zn-material-ui'
import logo from '@images/logo.png'

export default () =>
  createStyles({
    left: {
      position: 'relative',
      flex: 1,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      overflow: 'hidden',
      margin: '0',
      left: 0,
      top: 0,
    },
    logo: {
      width: '90px',
      height: '34px',
      margin: '50px 0 0 50px',
      background: `url(${logo}) no-repeat`,
      backgroundSize: '100% 100%',
    },
    loginUrl: {
      width: '150px',
      height: '80px',
    },
    urlContainer: {
      margin: '47px 20px 0',
    },
  })
